import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavigationContextType {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

interface NavigationProviderProps {
  children: ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() =>
    typeof window === 'undefined' || typeof window.matchMedia !== 'function' || !window.matchMedia('(max-width:899.95px)').matches
  );

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const value: NavigationContextType = {
    sidebarOpen,
    toggleSidebar,
    setSidebarOpen,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = (): NavigationContextType => {
  const context = useContext(NavigationContext);

  if (context === undefined) {
    throw new Error('useNavigationはNavigationProvider内で使用する必要があります');
  }

  return context;
};

export default NavigationContext;
